import React from "react";
import Date from "../Date";
import style from "../header.module.css";

const Icicc25=()=>{
    const links=[
        // {
    //     title:"Volume 1",
    //     anchor:"https://link.springer.com/book/9789819735877",
    //     val:"https://link.springer.com/book/9789819735877"
    // },
    // {
    //     title:"Volume 2",
    //     anchor:"https://link.springer.com/book/9789819735907",
    //     val:"https://link.springer.com/book/9789819735907"

    // },
    // {
    //     title:"Volume 3",
    //     anchor:"https://link.springer.com/book/9789819741519",
    //     val:"https://link.springer.com/book/9789819741519"
        
    // },
    // {
    //     title:"Volume 4",
    //     anchor:"https://link.springer.com/book/9789819738168",
    //     val:"https://link.springer.com/book/9789819738168"
    // },
    // {
    //     title:"Volume 5",
    //     anchor:"https://link.springer.com/book/9789819741489",
    //     val:"https://link.springer.com/book/9789819741489"

    // },
    // {
    //     title:"Volume 6",
    //     anchor:"https://link.springer.com/book/9789819742271",
    //     val:"https://link.springer.com/book/9789819742271"        
    // }
    ]
    const videos=[
        {
        title:"Inauguration and Vote of Thanks",
        anchor:<iframe width="360" height="240" src="https://www.youtube.com/embed/S0tAerJyf18?si=d_AiGVuiT14e6w2U" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>,
        
    },
    {
        title:"ICICC 2025 – Keynote 1: Address by Prof Roman Danel",
        anchor:<iframe width="360" height="240" src="https://www.youtube.com/embed/b4m6qOwf5kk?si=EYVwrCztmP85n2sV" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>

    },
    {
        title:"ICICC 2025 – Keynote 2: Address by Prof. Swagatam Das",
        anchor:<iframe width="360" height="240" src="https://www.youtube.com/embed/9hZfBYZKd94?si=2Q9xVZAkRB88WXyw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
    },
    {
      title:"ICICC 2025 – Keynote 3: Address by Dr Kathrin Kind Trüller",
      anchor:<iframe width="360" height="240" src="https://www.youtube.com/embed/BvjyFUUQkKw?si=oVNj22OzkOErLkyJ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
  }
    ]
  return(
  <div>
  <h2 class={style.abtHeader}>ICICC 2025</h2>
  <hr />
  <div className={style.flex}>
  <div className={style.abtInstCont}>
    <p style={{fontSize:15,letterSpacing:1}}>The eighth version of the International Conference in Innovative Computing and Communication (ICICC-2025) was organized at Shaheed Sukhdev College of Business Studies in association with the National Institute of Technology Patna and the University of Valladolid Spain, on 14-15 February 2025 at New Delhi, India. ICICC-2025 received 2000 papers from approximately 6000 plus authors and a total of 400 papers were accepted with an acceptance ratio of 20%. All accepted papers were published in Springer's Lecture Notes on Networks and Systems, a Scopus-indexed series. A total of 750 participants attended the conference including authors, keynotes, delegates, academicians, and industry experts. ICICC-2025 received papers from 35 countries. ICICC-2025 was organized in hybrid mode.</p><br />
{/* <h3>LINK OF PROCEEDINGS OF ICICC 2025</h3><br /> */}
<div className={style.volumes}>
		<table class="table table-bordered table-hover" style={{textAlign:"left"}}>
            <tbody>
            {links.map((link)=>{
                return (
                <tr>
                    <td><b>{link.title}:</b></td>
                    <td><a href={link.anchor}>{link.val}</a></td>
                </tr>
                );
            })}
              
            </tbody>
          </table>
</div>

    {/* <h3>VIDEOS OF ICICC 2025</h3><br /> */}
<div className={style.volumes}>
		<div class="table table-bordered table-hover" style={{textAlign:"left"}}>
            <div>
            {videos.map((link)=>{
                return (
                <div>
                    <h4>{link.title}:</h4>
                    {link.anchor}
                </div>
                );
            })}
              
            </div>
          </div>
</div>
  </div>
  <Date />

</div>


  </div>
);
};

export default Icicc25;
